module.exports = __webpack_public_path__ + "static/media/four-creativities-arrows.562b1dcd.svg";